import React, { useState, useEffect } from "react";
import bgImg from "../../assets/bg_img.jpg";
import success from "../../assets/success.svg";
import { Row, Col, Input, Button, Typography, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import arrowleft from "../../assets/back-arrow.svg";
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography;
const LoadMoney = () => {
  const navigate = useNavigate();
  function handleMoneyLoad() {
    navigate("/cart");
  }

  const handleBack = () => {
    navigate("/kyc");
  };
  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        height: "80vh",
        width: "100vw",
        position: "relative",
        color: "#fff",
        padding: "50px 20px 100px",
      }}
    >
      <Row
        justify="center"
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          maxWidth: 420,
          margin: "0 auto",
        }}
      >
        <Col span={24}>
          {/* Header */}
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              marginBottom: 20,
              height: 40,
            }}
          >
        
            {/* <img
              src={arrowleft}
              style={{ cursor: "pointer" }}
              alt="Back"
              onClick={handleBack}
            /> */}
            <Title
              level={4}
              style={{
                color: "#333333",
                margin: 0,
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                // width: "100%",
                textAlign: "center",
              }}
            >
              Complete Your KYC
            </Title>
          </div>

          <Text style={{ color: "#fff", fontWeight: 700, fontSize: "18px" }}>
            <span style={{ color: "#333333" }}>Welcome to </span>{" "}
            <span style={{ color: "#2348AB" }}>Khazana Card</span>
          </Text>

          <Title
            level={5}
            style={{ color: "#333333", marginTop: 20, marginBottom: 10 }}
          >
            Your KYC has been verified successfully.
          </Title>

          <Text
            style={{ color: "#9E9EA0", display: "block", marginBottom: 30 }}
          >
            You can now load money into your card.
          </Text>

          <div className="d-flex justify-content-center mb-4">
            <img src={success} />
          </div>

          <Button
            type="primary"
            block
            size="large"
            onClick={handleMoneyLoad}
            style={{
              backgroundColor: "#2348AB",
              borderRadius: 10,
              border: "none",
              boxShadow: "0 0 15px rgba(35,72,171,0.6)",
              fontWeight: 600,
            }}
          >
            Load Money
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default LoadMoney;
